import * as Actions from 'reducks/user/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const UserReducer = (state = initialState.user, action: any) => {
  switch (action.type) {
    case Actions.FETCH_USERS:
      return {
        ...state,
        users: [...action.payload],
      }
    case Actions.INIT_USERS:
      return {
        users: [],
      }
    default:
      return state
  }
}
